var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconScaleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ Scale+"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M20 5.5C28.0081 5.5 34.5 11.9919 34.5 20C34.5 23.4637 33.2855 26.6438 31.2591 29.1376L41.0607 38.9393C41.6464 39.5251 41.6464 40.4749 41.0607 41.0607C40.5281 41.5932 39.6948 41.6416 39.1076 41.2059L38.9393 41.0607L29.1376 31.2591C26.6438 33.2855 23.4637 34.5 20 34.5C11.9919 34.5 5.5 28.0081 5.5 20C5.5 11.9919 11.9919 5.5 20 5.5ZM20 8.5C13.6487 8.5 8.5 13.6487 8.5 20C8.5 26.3513 13.6487 31.5 20 31.5C26.3513 31.5 31.5 26.3513 31.5 20C31.5 13.6487 26.3513 8.5 20 8.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 14C21.5 13.1716 20.8284 12.5 20 12.5C19.1716 12.5 18.5 13.1716 18.5 14V18.5H14C13.1716 18.5 12.5 19.1716 12.5 20C12.5 20.8284 13.1716 21.5 14 21.5H18.5V26C18.5 26.8284 19.1716 27.5 20 27.5C20.8284 27.5 21.5 26.8284 21.5 26V21.5H26C26.8284 21.5 27.5 20.8284 27.5 20C27.5 19.1716 26.8284 18.5 26 18.5H21.5V14Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScaleWhite);
export default __webpack_public_path__ + "static/media/icon-scale-white.efe912b28bc795c3ba798d247c57fa7b.svg";
export { ForwardRef as ReactComponent };